<template>
  <div class="main-content">
    <the-header :title="t('Create application')" :buttons="headerButtons"/>
    <titan-form :schema="application"
                v-on:saveData="saveData()"
                :model="formData"
                :newItem="true"
    />
  </div>
</template>
<script>
    import TheHeader from '../../../admin/Layout/TheHeader'
    import ApplicationForm from './cardio-form';
    import VueFormGenerator from 'vue-form-generator';
    import TitanForm from '../../../core/Form/Form'

    export default {
        components: {
            TheHeader,
            ApplicationForm,
            TitanForm
        },

        methods: {
            saveData() {
                this.$store.dispatch('applications/create', {patient: this.formData.patient.id,protocol: this.formData.protocol.value}).then(res => {
                    this.$router.push({
                        name: 'manageApplication',
                        params: {
                            id: res.id,
                        }
                    });
                });
            },
            loadProtocolOptions(patient) {
                if (patient !== null) {
                    this.$store.dispatch('protocols/listForPatient', patient.id).then(response => {
                        let optionsList = [];
                        response.data.forEach(protocol => {
                            optionsList.push({value: protocol.id, name: protocol.shortName})
                        })
                        this.application[0].fields[1].values = optionsList;
                        return response.data;
                    });
                }
            }
        },
        mounted() {
            let patientId = this.$route.params.patientId;
            if(patientId > 0) {
                let patients = this.$store.getters['codeBook/get']('patient');
                let found = patients.filter(p => {
                    return p.id === parseInt(patientId)
                });
                if(found) {
                    this.formData.patient = found[0];
                    this.loadProtocolOptions(this.formData.patient);
                }
            }
        },
        data() {
            return {
                headerButtons: [
                    {
                        type: 'link',
                        to: {name: 'createPatient', params: {tab: 'base'}},
                        key: 'create',
                        name: this.t('Create patient'),
                        icon: 'plus',
                        styleClass: 'btn-primary'
                    }
                ],
                application: [
                    {
                        name: this.t('Select patient or create new one'),
                        type: 'main',
                        fields: [
                            {
                                type: 'titanSelect',
                                label: this.t('Patient'),
                                valueLabel: 'fullNameSurnameFirstWithBirthNumber',
                                model: 'patient',
                                codeBook: 'patient',
                                required: true,
                                validator: VueFormGenerator.validators.required,
                                onSelect: (item) => {
                                    this.loadProtocolOptions(item);
                                }
                            },
                            {
                                type: 'titanSelect',
                                label: this.t('Protocol'),
                                values: [],
                                model: 'protocol',
                                required: true,
                                validator: VueFormGenerator.validators.required
                            }
                        ]
                    },
                ],
                formData: {
                    patient: null,
                    protocol: null
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/applications/selectUser.vue